import { render, staticRenderFns } from "./PdvMain.vue?vue&type=template&id=4ff324d6"
import script from "./PdvMain.vue?vue&type=script&lang=js"
export * from "./PdvMain.vue?vue&type=script&lang=js"
import style0 from "./PdvMain.vue?vue&type=style&index=0&id=4ff324d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports